export default __webpack_public_path__ + "static/media/kelley_campbell.493f65f8.jpeg";